module.exports = __webpack_public_path__ + "img/text_inspector_electronico.c60f5493.png";